module.exports = __webpack_public_path__ + "files/14367343175bc65d6e20fd235c356db4.png";